<template>
  <div>
    <van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft" />
    <div class="menu_style">
      <div class="card_style1">
        <div class="layout_style border_style" @click="user_self_click">
          <div class="title_style">本人情报</div>
          <div><i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="layout_style border_style" @click="user_body_click">
          <div class="title_style">体质情报</div>
          <div><i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.push({
        path: "/menu",
      });
    },
    user_self_click() {
      this.$router.push({
        path: "/userSelf",
        query: {
          familyId: this.$route.query.familyId,
        },
      });
    },
    user_body_click() {
      this.$router.push({
        path: "/userBody",
        query: {
          familyId: this.$route.query.familyId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.menu_style {
  background: #f5f6f8;
  padding: 19px 15px 45px 15px;
}
.card_style1 {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 45px;
}
.layout_style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px 20px 10px;
}
.border_style {
  border-bottom: 1px solid #e5e9f0;
}
.title_style {
  color: #202f3b;
  font-size: 16px;
  font-weight: bold;
}
</style>